import { render, staticRenderFns } from "./SlideSearchResultItem.vue?vue&type=template&id=d5c12b4c&scoped=true&"
import script from "./SlideSearchResultItem.vue?vue&type=script&lang=js&"
export * from "./SlideSearchResultItem.vue?vue&type=script&lang=js&"
import style0 from "./SlideSearchResultItem.vue?vue&type=style&index=0&id=d5c12b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c12b4c",
  null
  
)

export default component.exports